<template>
  <nav class="product-category-nav" aria-label="products">
    <div class="product-category-nav__cats">
      <router-link
        to="/product/"
        class="product-category-nav__cat"
        :class="{ 'is-active': !activeSlug }"
      >
        {{ allLabel }}
      </router-link>
      <router-link
        v-for="cat in displayCategories"
        :key="cat.id"
        :to="'/product/' + cat.categorySlug + '/'"
        class="product-category-nav__cat"
        :class="{ 'is-active': isActiveCategory(cat) }"
      >
        {{ categoryLabel(cat) }}
      </router-link>
    </div>
    <div class="product-category-nav__subs" v-if="activeProducts.length">
      <router-link
        v-for="p in activeProducts"
        :key="p.id"
        :to="'/product/' + activeCatSlug + '/' + p.id + '.html'"
        class="product-category-nav__sub"
        :class="{ 'is-active': String(activeProductId) === String(p.id) }"
      >
        {{ $cleanBrand(p.productName) }}
      </router-link>
    </div>
  </nav>
</template>

<script>
import { listProductCategory, listProduct } from '@/utils/http'
import { unwrapRows } from '@/utils/content'
import { isSameProductSlug } from '@/constants/productSlugs'

export default {
  name: 'ProductCategoryNav',
  props: {
    activeSlug: { type: String, default: '' },
    activeProductId: { type: [String, Number], default: null },
    showSubs: { type: Boolean, default: true }
  },
  data() {
    return { categories: [], products: [] }
  },
  computed: {
    displayCategories() {
      return this.categories.filter(cat => {
        if (!cat.categorySlug || cat.status === 0) return false
        if (/^\d+$/.test(String(cat.categorySlug))) return false
        return true
      })
    },
    allLabel() {
      return this.$i18n.locale === 'zh' ? '\u5168\u90E8' : 'All'
    },
    activeCategory() {
      return this.displayCategories.find(c => this.isActiveCategory(c)) || null
    },
    activeCatSlug() {
      return (this.activeCategory && this.activeCategory.categorySlug) || this.activeSlug || ''
    },
    activeProducts() {
      if (!this.showSubs || !this.activeCategory) return []
      return this.getProducts(this.activeCategory.id)
    }
  },
  created() {
    this.load()
  },
  methods: {
    reloadCmsData() {
      this.load()
    },
    categoryLabel(cat) {
      return this.$navItemLabel('productNav', cat)
    },
    isActiveCategory(cat) {
      return isSameProductSlug(this.activeSlug, cat.categorySlug)
    },
    getProducts(catId) {
      const cat = this.categories.find(c => Number(c.id) === Number(catId))
      if (!cat) return []
      const cid = Number(catId)
      return this.products
        .filter(p => {
          if (Number(p.categoryId) === cid) return true
          const linked = this.categories.find(c => Number(c.id) === Number(p.categoryId))
          return linked && linked.categorySlug === cat.categorySlug
        })
        .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0) || Number(a.id) - Number(b.id))
    },
    async load() {
      const locale = this.$i18n.locale
      try {
        const [catRes, prodRes] = await Promise.all([
          listProductCategory({ status: 1, pageNum: 1, pageSize: 50 }, locale),
          listProduct({ status: 1, pageNum: 1, pageSize: 500 }, locale)
        ])
        const cats = unwrapRows(catRes)
        if (cats.length) {
          this.categories = cats.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
          this.products = unwrapRows(prodRes)
        } else {
          this.categories = []
          this.products = []
        }
      } catch (e) {
        this.categories = []
        this.products = []
      }
    }
  }
}
</script>
